// @mui
import { Container, Typography, Grid } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
// hooks
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useSettings from "../hooks/useSettings";
import { dispatch, useSelector } from "../redux/store";
// components
import Page from "../components/Page";
//
import { sendLocation } from "../redux/slices/sendLocation";
import { DisabledGPS, Location } from "../assets";
import { sendLinkLocation } from "../redux/slices/sendLinkLocation";
import config from "../config.json";

const { COMPLIANCE_SITES_HOSTS } = config;
// ----------------------------------------------------------------------

export default function Check() {
  const { themeStretch } = useSettings();
  const { data } = useSelector(({ sendLocation }) => sendLocation);
  const { data: dataLink } = useSelector(
    ({ sendLinkLocation }) => sendLinkLocation
  );
  const { id } = useParams();

  const redirectToMainPage = COMPLIANCE_SITES_HOSTS.includes(
    window.location.hostname
  );

  const isObjectId = /^[0-9a-fA-F]{24}$/.test(id);

  const receivedData = data || dataLink;

  const setNavigator = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position?.coords.latitude;
        const lng = position?.coords.longitude;
        dispatch(sendLocation({ token: id, lat, lng }));
      },
      () => {
        dispatch(sendLocation({ token: id }));
      }
    );
  };
  const setLinkNavigator = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position?.coords.latitude;
        const lng = position?.coords.longitude;
        dispatch(sendLinkLocation({ id, lat, lng }));
      },
      () => {
        dispatch(sendLinkLocation({ id }));
      }
    );
  };

  useEffect(() => {
    if (id) {
      if (!isObjectId && !data) {
        setNavigator();
      }
      if (isObjectId && !dataLink) {
        setLinkNavigator();
      }
      if (
        receivedData?.lat &&
        receivedData?.lng &&
        receivedData.lat !== "undefined"
      ) {
        window.location = redirectToMainPage
          ? "/"
          : `https://www.google.com/maps/place/${receivedData.lat}+${receivedData.long}`;
      }
    }
  }, [receivedData]);

  return (
    <Page title="Check location">
      <Container maxWidth={themeStretch ? false : "xl"}>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: "100vh" }}
        >
          <>
            {id && !receivedData && (
              <CircularProgress size={50} thickness={5} />
            )}
            {(!id || (receivedData && !receivedData.address)) && (
              <>
                <DisabledGPS />
                <Typography variant="h3" gutterBottom align="center">
                  Your GPS location is disabled
                </Typography>
                <Typography variant="subtitle2" gutterBottom align="center">
                  {/* eslint-disable-next-line react/no-unescaped-entities */}
                  Please enable your location in your browser's settings
                </Typography>
              </>
            )}
            {receivedData?.address && (
              <>
                <Location />
                <Typography variant="h3" gutterBottom align="center">
                  Your location:
                </Typography>
                <Typography variant="subtitle2" align="center">
                  {receivedData.address || "Located"}
                </Typography>
              </>
            )}
          </>
        </Grid>
      </Container>
    </Page>
  );
}
